import type { HomeApiResponse } from '@/domains/home/home.entity';
import type { HomeRepository } from '@/domains/home/home.repository';
import { homeApiService } from '../http/home.api';

/**
 * Repositorio de métricas globales del dashboard principal
 * Cumple con ISP: interfaz segregada para datos del home
 */
class HomeApiRepository implements HomeRepository {
  /**
   * Obtiene métricas globales de la institución para el dashboard principal
   */
  async getMetricsForTheHome(): Promise<HomeApiResponse> {
    const metricsForHomeResponse = await homeApiService.getMetricsForTheHome();

    if (!metricsForHomeResponse)
      throw new Error('Error al obtener las métricas globales');

    return metricsForHomeResponse;
  }
}

export const homeApiRepository = new HomeApiRepository();
